var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "secondary-nav" }, [
    _c(
      "div",
      {
        staticClass:
          "gap-10 d-flex justify-content-between align-items-center w-100 h-100",
      },
      [
        _c("div", { staticClass: "h-100" }, [
          _vm.activeStage.preview === false && _vm.activeStage.mainJob !== null
            ? _c(
                "div",
                { staticClass: "h-100 draw-settings" },
                [_c("draw-settings")],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex gap-10px h-100" }, [
          _c("div", { staticClass: "magic-tools-container" }, [
            _vm.activeStage.mainJob !== null
              ? _c(
                  "div",
                  { staticClass: "magic-tool", on: { click: _vm.zoomFit } },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "40",
                          height: "40",
                          viewBox: "0 0 24 24",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1.5",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-miterlimit": "1",
                                d: "M15 12a3 3 0 1 0-6 0a3 3 0 0 0 6 0",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M9.4 21c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6m18 0c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21m0-18c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4M9.4 3c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C3 6.04 3 7.16 3 9.4",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.resultPage.isFullRes === true
                      ? _c("span", [_vm._v(_vm._s(_vm._f("trans")("Center")))])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.mainJob !== null
              ? _c(
                  "div",
                  { staticClass: "magic-tool", on: { click: _vm.zoomIn } },
                  [
                    _c("i", { staticClass: "far fa-search-plus" }),
                    _vm._v(" "),
                    _vm.resultPage.isFullRes === true
                      ? _c("span", [_vm._v(_vm._s(_vm._f("trans")("Zoom In")))])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeStage.mainJob !== null
              ? _c(
                  "div",
                  { staticClass: "magic-tool", on: { click: _vm.zoomOut } },
                  [
                    _c("i", { staticClass: "far fa-search-minus" }),
                    _vm._v(" "),
                    _vm.resultPage.isFullRes === true
                      ? _c("span", [
                          _vm._v(_vm._s(_vm._f("trans")("Zoom Out"))),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }